import type { Observable } from 'rxjs';

import type { PageQuery, PagedResult } from '@domain/models/paged-result.model';
import type { StoreSettlement } from '@domain/models/store.model';

export abstract class SettlementRepository {
  abstract list(query: PageQuery): Observable<PagedResult<StoreSettlement>>;
}
